<template>
  <a-card class="custom-page-box">
    <Breadcrumb routeName="MemberList" toName="佣金记录" goPathName="成员列表"></Breadcrumb>
    <search-page-view
      :col="3"
      ref="pageList"
      :itemNames="['search_item_1','search_item_2','search_item_3','search_item_4','search_item_5']"
      :buttonItems="['download']"
      :columns="columns"
      :queryParams="queryParams"
      @reset="resetEvent"
      :requestPromise="getRequestPromise"
      :exportType="2"
      @export="exportEventRecord"
    >
      <a-form-item slot="search_item_1" label="订单编号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_item_2" label="资金流向" v-bind="searchItemLayout">
        <a-select
          style="width: 100%"
          v-model="queryParams.capitalFlow"
          @change="onCapitalFlowChange"
          placeholder="请选择"
        >
          <a-select-option v-for="item in capitalFlowList" :key="item.code" :value="item.code">{{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="search_item_3" label="收支类别" v-bind="searchItemLayout">
        <a-select
          style="width: 100%"
          v-model="queryParams.category"
          @change="onCategoryChange"
          placeholder="请选择"
        >
          <a-select-option v-for="item in typeList" :key="item.code" :value="item.code">{{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item slot="search_item_4" label="商品ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_item_5" label="交易日期" v-bind="searchItemLayout">
        <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
      </a-form-item>
      <a-button slot="download" style="margin-left: 8px" @click="handleLook">查看已生成报表</a-button>
      <div slot="operation" style="padding: 20px;margin: 20px">
        <detail-list :col="4" layout="vertical">
          <detail-list-item term="收入金额">{{ details.incomeAmount }}元</detail-list-item>
          <detail-list-item term="收入笔数">{{ details.incomeCount }}笔</detail-list-item>
          <detail-list-item term="支出金额">{{ details.expenditureAmount }}元</detail-list-item>
          <detail-list-item term="支出笔数">{{ details.expenditureCount }}笔</detail-list-item>
        </detail-list>
      </div>
      <span slot="rule_type" slot-scope="rowItem">{{ rowItem.text }}</span>
      <span slot="settle_period" slot-scope="rowItem">T+{{ rowItem.text }}</span>
      <span slot="state" slot-scope="rowItem">{{ rowItem.text }}</span>
    </search-page-view>
  </a-card>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import searchForm from '../../../utils/mixins/searchFormMixins'

export default {
  name: 'CommissionRecord',
  mixins: [searchForm],
  components: { Breadcrumb },
  data() {
    return {
      queryParams: {},
      staffId: '',
      typeList: [],
      selectedDate: undefined,
      capitalFlowList: [],
      details: {},
      columns: [
        {
          title: '订单编号',
          dataIndex: 'orderNo'
        },
        {
          title: '资金流向',
          dataIndex: 'capitalFlow'
        },
        {
          title: '收支类别',
          dataIndex: 'category'
        },
        {
          title: '收支金额(元)',
          dataIndex: 'amount'
        },
        {
          title: '创建时间',
          dataIndex: 'recordTime'
        }
      ],
      isFirstEnter: false
    }
  },
  created() {
    this.getLogUtils().logWithTag('created第一次进来')
    this.capitalFlowList = this.getAppConstants().getCapitalFlow()
    this.typeList = this.getAppConstants().getIncomeAndExpenditureCategories()
    this.staffId = this.getPageParams().staffId
    this.queryParams.staffId = this.staffId
    this.queryParams.category = this.typeList[0].code
    this.queryParams.capitalFlow = this.capitalFlowList[0].code
  },
  activated() {
    // 因为需要缓存数据，所以页面进来时需要调一次接口
    //当引入keep-alive的时候，页面第一次进入，钩子的触发顺序created-> mounted-> activated，退出时触发deactivated。当再次进入（前进或者后退）时，只触发activated。
    this.getNewData()
  },
  mounted() {
  },
  methods: {
    getNewData() {
      this.getLogUtils().logWithTag('activated第二次进来')
      this.staffId = this.getPageParams().staffId
      this.queryParams.staffId = this.staffId
      this.queryParams.category = this.typeList[0].code
      this.queryParams.capitalFlow = this.capitalFlowList[0].code
      this.getLogUtils().logWithTag('staffId', this.staffId)
      this.$refs.pageList.refresh(true)
    },
    getRequestPromise(parameter) {
      this.getStaffCommissionStatistics(parameter)
      return this.getHttpServices().getUserService().post('staff/v2/getStaffCommission', parameter)
    },
    getStaffCommissionStatistics(parameter) {
      this.getHttpServices().getUserService().post('staff/v2/getStaffCommissionStatistics', parameter)
        .then(details => {
          this.details = details
          this.getLogUtils().logWithTag('getStaffCommissionStatistics', details)
        }).catch(reason => this.getLogUtils().errorWithTag('getStaffCommissionStatistics', reason))
    },
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.startTime = dateStrArr[0]
      this.queryParams.endTime = dateStrArr[1]
    },
    onCategoryChange(value) {
      this.queryParams = {
        ...this.queryParams,
        category: value
      }
    },
    onCapitalFlowChange(value) {
      this.queryParams = {
        ...this.queryParams,
        capitalFlow: value
      }
    },
    resetEvent() {
      this.selectedDate = undefined
      this.queryParams = {
        staffId: this.staffId,
        category: 0,
        capitalFlow: 0
      }
    },
    // 导出佣金的接口
    exportEventRecord() {
      this.getHttpServices().getUserService().post('staff/v2/exportProductList', this.queryParams)
        .then(details => {
          this.$message.success('操作成功')
          this.getLogUtils().logWithTag('exportEventRecord', details)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 查看已生产报表
    handleLook() {
      this.$router.push({
        name: 'DownloadTable'
      })
    }
  }

}
</script>
<style lang="less">
@import "../../CustomPage";
</style>